import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/nmi/cart-creditcard-nmi.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";

export class CartCreditCardNmiController extends Shared {
	constructor($cart, $sce) {
		super($cart, $sce);
		let $rootScope = resolve("$rootScope");
		let $stateParams = resolve("$stateParams");
		let $ctrl = this;
		$ctrl.paymentMethod = {};
		if ($ctrl.retailer) {
			$ctrl.paymentMethod = {
				// name: $ctrl.retailer.companyName,
				// address: $ctrl.retailer.address,
				// address2: $ctrl.retailer.address2,
				// city: $ctrl.retailer.city,
				// state: $ctrl.retailer.state,
				// zip: $ctrl.retailer.zip,
				retailerId: $ctrl.retailer.id,
				country: $ctrl.retailer.country.toUpperCase() == "UNITED STATES" ? "US" : $ctrl.retailer.country.toUpperCase() == "CANADA" ? "CA" : $ctrl.retailer.country,
			};
		} else if ($stateParams.cartId) {
			$cart.load($stateParams.cartId);
			$ctrl.paymentMethod = {
				// name: $ctrl.$cart.buyer || $ctrl.$cart.billingLocation.companyName,
				// address: $ctrl.$cart.purchaser.address,
				// address2: $ctrl.$cart.purchaser.address2,
				// city: $ctrl.$cart.purchaser.city,
				// state: $ctrl.$cart.purchaser.state,
				// zip: $ctrl.$cart.purchaser.zip,
				country: $ctrl.$cart.purchaser.country.toUpperCase() == "UNITED STATES" ? "US" : $ctrl.$cart.purchaser.country.toUpperCase() == "CANADA" ? "CA" : $ctrl.$cart.purchaser.country,
			};
		} 
		$ctrl.bus = new ServiceBus;
		$ctrl.cartConfig = cartConfig;
		let retailerId = $ctrl.retailer ? $ctrl.retailer.id : $ctrl.$cart.retailerId;

		CollectJS.configure({
			'paymentSelector' : '#customPayButton',
			'theme': 'bootstrap',
			'tokenizationKey': ($ctrl.paymentMethod.country == "US" || $ctrl.paymentMethod.country == "United States") ? "3ke4Tc-D7t5fj-qUNU4y-x4caau" : "bwfJ7x-9S533w-8QkrnV-Jxw8CJ",
			'buttonText': 'Submit',
			'instructionText': 'Enter Card Info Below',
			'paymentType': 'cc',
			'price': $ctrl.$cart.grandTotal || 0,
			'currency':'USD',
			'country': 'US',
			'callback' : function(response) {
				if (response.token) {
					console.log(JSON.stringify(response.token));
					$ctrl.paymentMethod.isPrimary = true;
					$ctrl.paymentMethod.tokenizationCode = response.token;
					$ctrl.paymentMethod.tokenizationProvider = "NMI";
					$ctrl.paymentMethod.number = "TOKEN";
					$ctrl.paymentMethod.type = response.card.type;
					$ctrl.paymentMethod.lastFour = response.card.number.substr(response.card.number.length - 4);
					$ctrl.paymentMethod.expirationMonth = response.card.exp.substr(0,2);
					$ctrl.paymentMethod.expirationYear = response.card.exp.substr(2,2);
					$ctrl.paymentMethod.retailerId = $ctrl.$cart.shippingLocation.id, // $ctrl.retailer ? $ctrl.retailer.id : $ctrl.$cart.purchaser.id || $ctrl.$cart.retailerId;
					$ctrl.paymentMethod.expiration =
						$ctrl.paymentMethod.expirationMonth + $ctrl.paymentMethod.expirationYear;
					$ctrl.paymentMethod.expiresOn =
						$ctrl.paymentMethod.expirationMonth +
						"/1/" +
						$ctrl.paymentMethod.expirationYear;
					$ctrl.paymentMethod.cartId = $ctrl.$cart.id;
					console.debug(
						"$ctrl.$cart.errorToastFactory",
						$ctrl.$cart.errorToastFactory
					);
					$ctrl.$cart.bus.send(`QueryRetailerPaymentMethods?RetailerId=${$ctrl.$cart.shippingLocation.id}&TokenizationProvider=NMI&LastFour=${$ctrl.paymentMethod.lastFour}&Expiration=${moment($ctrl.paymentMethod.expiresOn).format("MMYYYY")}`).then(function(res) {
						if (res.data.results.length) {
							$ctrl.paymentMethod.tokenizationProvider = "NMI";
							$ctrl.paymentMethod.tokenizationCode = res.data.results[0].tokenizationCode;
							$ctrl.newCardID = res.data.results[0].tokenizationCode;
							$rootScope.$broadcast("creditCardCreated", { id: res.data.results[0].tokenizationCode});
							//window.location.reload();
						} else {
							$ctrl.$cart.bus.send("NMI/AddVault", {
								payment_token: response.token,
								name_on_card: $ctrl.paymentMethod.name,
								address: $ctrl.paymentMethod.address,
								city: $ctrl.paymentMethod.city,
								state: $ctrl.paymentMethod.state,
								zipcode: $ctrl.paymentMethod.zip,
								country: $ctrl.paymentMethod.country
							}).then(function(res) {
								if (res.data.vaultId) {
									$ctrl.paymentMethod.tokenizationCode = res.data.vaultId;
									$ctrl.$cart.bus.send(
										"CreateRetailerPaymentMethod.json",
										$ctrl.paymentMethod
									)
									.then(function (res) {
										$ctrl.newCardID = res.tokenizationCode;
										$rootScope.$broadcast("creditCardCreated", {id: res.data.tokenizationCode});
										//window.location.reload();
									}, $ctrl.$cart.errorToastFactory("saveCardFailed"));
								}
							});
						}
					})
			
				 }
			}
		});
	}
	initNmi() {
		let $ctrl = this;
	}
	toggleSameAsCorporate() {
		let $ctrl = this;
		if ($ctrl.sameAsCorporate) {
			$ctrl.paymentMethod.address =
				$ctrl.$cart.purchaser.address || $ctrl.$cart.billingLocation.address;
			$ctrl.paymentMethod.address2 =
				$ctrl.$cart.purchaser.address2 || $ctrl.$cart.billingLocation.address2;
			$ctrl.paymentMethod.city =
				$ctrl.$cart.purchaser.city || $ctrl.$cart.billingLocation.city;
			$ctrl.paymentMethod.state =
				$ctrl.$cart.purchaser.state || $ctrl.$cart.billingLocation.state;
			$ctrl.paymentMethod.zip =
				$ctrl.$cart.purchaser.zip || $ctrl.$cart.billingLocation.zip;
			$ctrl.paymentMethod.country =
				$ctrl.$cart.purchaser.country || $ctrl.$cart.billingLocation.country;
		}
	}
}

export default {
	bindings: {
		retailerId: "@",
		retailer: "<",
		returnUri: "@"
	},
	controller: CartCreditCardNmiController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
